// useRecuperarContrasena — la lógica de «¿Has olvidado tu contraseña?», sin diseño.
//
// La usan la pantalla por defecto (/recuperar-contrasena) y la sección del
// builder `recuperar_contrasena`, que la pinta con el diseño de cada proyecto.
//   · sin token → pedir el enlace (`solicitar`)
//   · ?token=…  → comprobar el enlace y guardar la contraseña nueva (`cambiar`)
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { recuperarContrasenaService } from '../services/api';

const useRecuperarContrasena = () => {
  const [params] = useSearchParams();
  const token = params.get('token') || '';

  const [identificador, setIdentificador] = useState('');
  const [password, setPassword] = useState('');
  const [repetir, setRepetir] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [aviso, setAviso] = useState(null);           // { texto, error }
  const [tokenOk, setTokenOk] = useState(null);       // null = comprobando
  const [nombre, setNombre] = useState('');
  const [minimo, setMinimo] = useState(6);
  const [listo, setListo] = useState(false);
  // El proyecto puede avisar que el correo no está registrado (código
  // `no_registrado`); entonces se ofrece volver a intentar o crear la cuenta.
  const [noRegistrado, setNoRegistrado] = useState(false);

  useEffect(() => {
    if (!token) return;
    recuperarContrasenaService.validar(token)
      .then(r => {
        setTokenOk(!!r.data.success);
        if (r.data.success) {
          setNombre(r.data.nombre || '');
          setMinimo(r.data.minimo || 6);
        } else {
          setAviso({ texto: r.data.message, error: true });
        }
      })
      .catch(() => { setTokenOk(false); setAviso({ texto: 'No se pudo comprobar el enlace. Inténtalo de nuevo.', error: true }); });
  }, [token]);

  const solicitar = async (e) => {
    if (e) e.preventDefault();
    if (!identificador.trim()) return;
    setEnviando(true);
    setAviso(null);
    setNoRegistrado(false);
    try {
      const r = await recuperarContrasenaService.solicitar(identificador.trim());
      if (r.data?.code === 'no_registrado') {
        setAviso({ texto: r.data.message, error: true });
        setNoRegistrado(true);
      } else {
        setAviso({ texto: r.data.message, error: false });
        setListo(true);
      }
    } catch (err) {
      setAviso({ texto: err.response?.data?.message || 'No se pudo enviar la solicitud. Inténtalo de nuevo.', error: true });
    }
    setEnviando(false);
  };

  const cambiar = async (e) => {
    e.preventDefault();
    if (password.length < minimo) {
      setAviso({ texto: `La contraseña debe tener al menos ${minimo} caracteres.`, error: true });
      return;
    }
    if (password !== repetir) {
      setAviso({ texto: 'Las dos contraseñas no coinciden.', error: true });
      return;
    }
    setEnviando(true);
    setAviso(null);
    try {
      const r = await recuperarContrasenaService.cambiar(token, password);
      setAviso({ texto: r.data.message, error: false });
      setListo(true);
    } catch (err) {
      setAviso({ texto: err.response?.data?.message || 'No se pudo guardar la contraseña.', error: true });
    }
    setEnviando(false);
  };

  // Vuelve al formulario (tras «no registrado»), con el correo escrito.
  const reintentar = () => {
    setAviso(null);
    setNoRegistrado(false);
    setListo(false);
  };

  return {
    token, identificador, setIdentificador, password, setPassword, repetir, setRepetir,
    enviando, aviso, tokenOk, nombre, minimo, listo, noRegistrado, solicitar, reintentar, cambiar,
  };
};

export default useRecuperarContrasena;
